import styled from 'styled-components';
import { Dialog } from '@kinesis/bungle';

const BoundedDialog = styled(Dialog)`
  max-height: calc(100vh - 174px);
`;

export { BoundedDialog };
